export default {
      id: "x-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#x",
      toString: function () {
        return this.url;
      }
    }